import { IonIcon } from '../../Icons/IonIcon'
import {
  EmptyState,
  EmptyStateAction,
  EmptyStateDescription,
  EmptyStateHeader,
  EmptyStateTitle,
} from '../../components/ui/empty'

const NoActivitiesYet = ({ onShare }: { onShare: () => void }) => {
  return (
    <EmptyState
      iconClassName='text-blue-s3'
      className='p-4 gap-4'
      icon='c_activity'
      iconSize='small'
    >
      <EmptyStateHeader>
        <EmptyStateTitle>No activities yet</EmptyStateTitle>
        <EmptyStateDescription>
          See all actions performed by the stakeholders within the space here.
        </EmptyStateDescription>
      </EmptyStateHeader>
      <EmptyStateAction onClick={onShare}>
        <IonIcon name='share-outline' />
        Share the space
      </EmptyStateAction>
    </EmptyState>
  )
}

export default NoActivitiesYet
